import { useState, useEffect } from "react"

import axios from "axios"
import { PLANNER_TAG } from "src/configuration"
import { authRequest } from "src/engine/modules/authRequest"
import isEmpty from "lodash/isEmpty"
import get from "lodash/get"
import env from "src/env"

export function usePlanTemplates(currentToken, planId) {
  const [isTemplates, setTemplates] = useState({
    pending: false,
    data: [],
    errors: false,
  })

  const { REACT_APP_REPORT_SERVICE_URL } = env
  const REPORT_TEMPLATES_URL = `${REACT_APP_REPORT_SERVICE_URL}/qs/objects/template/byFilter`
  const PAGE = 1
  const HUGE_PER_PAGE = 1000

  useEffect(() => {
    authRequest({ url: `/plans/${planId}/reports/templates` })
      .then(response => {
        const responseData = get(response, `data`) || []
        // TODO: recommit after reference fix filter
        if (!isEmpty(responseData)) {
          const filterCrutch = []
          responseData.map(code =>
            filterCrutch.push({
              type: `EQUAL`,
              left: {
                type: `COMMON_ATTRIBUTE`,
                attribute: `code`,
              },
              right: {
                type: `constant`,
                dataType: {
                  type: `TEXT`,
                },
                value: code,
              },
            }),
          )
          setTemplates({ pending: true, data: [], error: false })
          axios({
            method: `POST`,
            url: `${REPORT_TEMPLATES_URL}?token=${currentToken}&page=${PAGE}&perPage=${HUGE_PER_PAGE}`,
            data: {
              sorting: [{ code: `createDate`, direction: `DESC` }],
              filter: {
                type: `AND`,
                operands: [
                  // TODO: recommit after reference fix filter
                  // {
                  //   type: `IN`,
                  //   left: {
                  //     type: `COMMON_ATTRIBUTE`,
                  //     attribute: `code`,
                  //   },
                  //   right: {
                  //     type: `constant`,
                  //     dataType: {
                  //       type: `TEXT`,
                  //     },
                  //     value: response.data,
                  //   },
                  // },
                  {
                    type: `OR`,
                    operands: filterCrutch,
                  },
                  {
                    type: `CONTAINS`,
                    left: { type: `COMMON_ATTRIBUTE`, attribute: `tags` },
                    right: {
                      type: `constant`,
                      dataType: { type: `TEXT` },
                      value: [PLANNER_TAG],
                    },
                  },
                ],
              },
            },
          })
            .then(templates => {
              setTemplates({
                pending: false,
                data: templates.data,
                error: false,
              })
            })
            .catch(errors => {
              setTemplates({
                pending: false,
                data: errors.data,
                error: true,
              })
            })
        } else
          setTemplates({
            pending: false,
            data: [],
            error: false,
          })
      })
      .catch(errors => {
        setTemplates({
          pending: false,
          data: errors.data,
          error: true,
        })
      })
  }, [planId])

  return isTemplates
}
